<template>
    <div>
        <PreLoader v-if="isLoading"/>
        <SuperAdminSchoolHead style="align-items: flex-start" class="sas-head">
            <template v-slot:title><span class="sas-title" v-html="$t('rayono')"/></template>
        </SuperAdminSchoolHead>
        <div class="scl-ad">
            <SmartTable :schools="rayonHeads" :total-elements="rayonHeads.length" :totalPages="1"
                        :page-size="rayonHeads.length" :current-page="1">
                <template v-slot:firstItem>
                    <div class="sas-head-center-block" style="align-items: flex-start">
                        <v-select :items="currentRegions" item-text="title" item-value="id" v-model="filterRegionId"
                                  :label="$t('region')" @change="fetchRayonsByRegion" outlined dense
                                  style="max-width: 276px" @click:append-outer="filterRegionId = ''"
                                  :no-data-text="$t('no_data')"
                                  :append-outer-icon="filterRegionId !== '' ? 'mdi-close' : ''"/>
                        <v-select :items="filteredRayons" item-text="title" item-value="id" v-model="filterRayonId"
                                  :label="$t('district')" clearable outlined dense
                                  style="max-width: 276px" @click:append-outer="filterRayonId = ''"
                                  :no-data-text="$t('no_data')"
                                  :append-outer-icon="filterRayonId !== '' ? 'mdi-close' : ''"/>
                        <v-btn color="primary" @click="fetchAllRayonHeads" v-text="`Фильтр`"/>
                    </div>
                </template>
                <template v-slot:head>
                    <th v-html="$t('full_name')"/>
                    <th v-html="$t('district')"/>
                    <th v-html="`Логин/Пароль`"/>
                    <th/>
                </template>
                <template v-slot:body="{item}">
                    <td v-html="`${item['userLastName']} ${item['userFirstName']}`"/>
                    <td v-html="item['rayonTitle']"/>
                    <td v-html="item['username']"/>
                    <td>
                        <v-btn icon text color="primary" @click="openRayonHeadModal('edit', item)">
                            <v-icon color="primary">mdi mdi-pencil-outline</v-icon>
                        </v-btn>
                    </td>
                </template>
            </SmartTable>
        </div>
        <v-dialog v-model="editRayonHead">
            <div class="modal-container">
                <div class="modal-title" v-html="mode === 'add' ? 'Добавить Районо' : 'Редактировать Районо'"/>
                <v-form ref="form">
                    <v-text-field :label="$t('firstname')" v-model="sendUserObj.name"
                                  :rules="required" outlined dense/>
                    <v-text-field :label="$t('surname')" v-model="sendUserObj.surname"
                                  :rules="required" outlined dense/>
                    <v-select :items="currentRegions" item-text="title" item-value="id" :label="$t('region')"
                              v-model="regionId" @change="fetchRayonsByRegion" outlined dense/>
                    <v-select :rules="required" :items="filteredRayons" item-text="title" item-value="id"
                              :label="$t('district')" v-model="sendRayonHeadObj.rayonId" outlined dense/>
                </v-form>
                <div class="btn-actions">
                    <v-btn color="primary" @click="closeRayHeadModal" v-text="$t('cancel')"/>
                    <v-btn color="green" @click="submit" v-text="$t('save')"/>
                </div>
            </div>
        </v-dialog>
    </div>
</template>

<script>
import { userService } from '@/_services/user.service'
import RayonHeadService from '@/_services/rayon-head.service'
import { RoleService } from '@/_services/role.service'
import { RayonService } from '@/_services/rayon.service'
import SmartTable from '@/components/table/SmartTable'
import PreLoader from '@/components/preloader/PreLoader'
import SuperAdminSchoolHead from "@/components/super-admin/schools/SuperAdminSchoolHead.vue";
const roleService = new RoleService()
const rayonService = new RayonService()

export default {
    components: {SuperAdminSchoolHead, SmartTable, PreLoader},
    data () {
        return {
            required: [v => !!v || this.$t('Обязательное поле')],
            sendUserObj: {
                name: '',
                surname: '',
                roles: [],
                enabled: true,
                email: '',
                username: '',
                password: ''
            },
            sendRayonHeadObj: {rank: '', rayonId: '', userId: 0},
            isLoading: false,
            editRayonHead: false,
            mode: '',
            regionId: '',
            filterRayonId: '',
            filterRegionId: '',
            rayonHeads: [],
            allRoles: [],
            filteredRayons: []
        }
    },
    computed: {
        currentRegions () {
            return this.$store.state.location.regions
        }
    },
    created () {
        this.fetchAllRayonHeads()
        this.fetchAllRoles()
    },
    methods: {
        fetchAllRayonHeads () {
            this.isLoading = true
            RayonHeadService.getAllRayonHeads(this.filterRegionId, this.filterRayonId)
                .then((res) => {
                    this.rayonHeads = res
                    this.isLoading = false
                })
                .catch((err) => {
                    this.$toast.error(err)
                    this.isLoading = false
                })
        },
        fetchAllRoles () {
            roleService.listPageable().then((res) => this.allRoles = res).catch((err) => this.$toast.error(err))
        },
        async openRayonHeadModal (mode, rayHead) {
            this.mode = mode
            if (mode === 'add') {
                this.sendUserObj.name = ''
                this.sendUserObj.surname = ''
                this.regionId = ''
                this.sendRayonHeadObj.rayonId = ''
            } else {
                await this.fetchRayonById(rayHead.rayonId)
                this.sendUserObj.name = rayHead['userFirstName']
                this.sendUserObj.surname = rayHead['userLastName']
                this.sendUserObj.id = rayHead.userId
                this.sendRayonHeadObj.rayonId = rayHead.rayonId
                this.sendRayonHeadObj.id = rayHead.id
                this.sendRayonHeadObj.userId = rayHead.userId
            }
            this.editRayonHead = true
        },
        closeRayHeadModal () {
            this.editRayonHead = false
        },
        fetchRayonsByRegion (regionId) {
            rayonService.listByRegion(regionId)
                .then((res) => this.filteredRayons = res)
                .catch((err) => this.$toast.error(err))
        },
        fetchRayonById (rayonId) {
            rayonService.getById(rayonId)
                .then((res) => {
                    this.regionId = res.region.id
                    this.fetchRayonsByRegion(this.regionId)
                })
                .catch((err) => this.$toast.error(err))
        },
        submit () {
            if (this.$refs.form.validate()) {
                this.isLoading = true
                this.sendUserObj.roles = this.allRoles.filter(i => i.code === 'ROLE_RAYON_HEADER').map(i => i.id)
                if (this.mode === 'add') {
                    userService.registerUser(this.sendUserObj)
                        .then((res) => {
                            this.sendRayonHeadObj.userId = res.user.id
                            RayonHeadService.createHeadRayon(this.sendRayonHeadObj).then(() => {
                                this.fetchAllRayonHeads()
                                this.$toast.success('Успешно создано!')
                                this.closeRayHeadModal()
                            }).catch((err) => {
                                this.$toast.error(err)
                                this.isLoading = false
                            })
                        })
                        .catch((err) => {
                            this.$toast.error(err)
                            this.isLoading = false
                        })
                } else {
                    userService.updateUser(this.sendUserObj).then(() => {
                        RayonHeadService.updateHeadRayon(this.sendRayonHeadObj).then(() => {
                            this.fetchAllRayonHeads()
                            this.$toast.success('Успешно обновлено!')
                            this.closeRayHeadModal()
                        }).catch((err) => {
                            this.$toast.error(err)
                            this.isLoading = false
                        })
                    }).catch((err) => {
                        this.$toast.error(err)
                        this.isLoading = false
                    })
                }
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.modal-title {
    text-align: center;
    margin-bottom: 20px;
}
</style>
